import {
  updateOverfoerteLektioner,
  type OverfoerteLektionerResultatDTO,
  type UpdateOverfoerteLektionerBody,
} from "@/api/person/efteruddannelse";
import { useMutation, type UseMutationResult } from "@tanstack/react-query";

export interface UpdateOverfoerteLektionerParams {
  personId: string;
  /** Perioden lektionerne overføres TIL — personens aktuelle, åbne periode. */
  efteruddannelseId: string;
  body: UpdateOverfoerteLektionerBody;
}

/**
 * Retter de lektioner, der er overført IND i en efteruddannelsesperiode.
 *
 * Perioderne læses via Apollo (PERSON_BY_ID_QUERY), ikke react-query, så cachen kan ikke
 * invalideres med queryClient. Kaldere skal give Apollos `refetch` videre og kalde den i
 * `onSuccess` — se `EditOverfoerteLektionerModal`.
 */
export const useUpdateOverfoerteLektioner = (): UseMutationResult<
  OverfoerteLektionerResultatDTO,
  Error,
  UpdateOverfoerteLektionerParams
> =>
  useMutation({
    mutationFn: ({ personId, efteruddannelseId, body }) =>
      updateOverfoerteLektioner(personId, efteruddannelseId, body),
  });
